// extracted by mini-css-extract-plugin
export default {"filePreviewContainer":"FilePreview_filePreviewContainer__zroqd"};